import { EnterpriseEbookContent } from './models/enterprise-ebook-content';
import { EnterpriseInfographicContent } from './models/enterprise-infographic-content';
import { EnterpriseLiveEventContent } from './models/enterprise-live-event-content';
import { EnterpriseReportContent } from './models/enterprise-report-content';
import { AllEnterpriseResourceContent } from './models/enterprise-resources-content';
import { EnterpriseVideoContent } from './models/enterprise-video-content';
import { EnterpriseWebinarContent } from './models/enterprise-webinar-content';

export const isEbookResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseEbookContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'ebook'
  );
};

export const isInfographicResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseInfographicContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'infographic'
  );
};

export const isReportResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseReportContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'report'
  );
};

export const isWebinarResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseWebinarContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'webinar'
  );
};

export const isLiveEventResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseLiveEventContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'live-event'
  );
};

export const isVideoResource = (
  resource: AllEnterpriseResourceContent | unknown
): resource is EnterpriseVideoContent => {
  return Boolean(
    resource && typeof resource === 'object' && 'resourceType' in resource && resource.resourceType === 'video'
  );
};
